// eslint-disable-next-line
import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import PlayIcon from '@material-ui/icons/PlayCircleFilled';
import PauseIcon from '@material-ui/icons/PauseCircleFilled';
import AccountSelect from '../account/AccountSelect';
import * as accountSelectors from '../account/selectors';
import * as coreSelectors from '../core/selectors';
import * as phoneSelectors from '../phone/selectors';
import * as accountActions from '../account/actions';
import * as coreActions from '../core/actions';
import * as serviceActions from './actions';
import * as phoneActions from '../phone/actions';
import * as Formatters from '../ui/Formatters';
import PhoneTextFieldWithFlag from '../ui/PhoneTextFieldWithFlag';
import CallFowarding from './CallForwarding';

const styles = theme => ({
    headings: {
        fontFamily: 'Sofia-bold',
        fontSize: 22
    },
    details: {
        fontFamily: 'Sofia',
    },
    minutesPlayed: {
        fontFamily: 'Sofia',
        fontSize: 14,
        margin: 7
    }
})

class RubySettings extends Component {

    checkRecordingSelection(){
        if(this.state.contactOptions.length === 0){
            let contactOptions = [];
            this.props.user?.contacts?.forEach(contact => {
                contact?.contactMethods?.filter(method => method.contactMethodType === 'PHONE')?.forEach(method => {
                    contactOptions.push({
                        display: `${contact.displayName} ${Formatters.formatPhoneNumber(method.phoneNumber)}`,
                        phoneNumber: method.phoneNumber
                    })
                })
            })
            if(contactOptions.length > 0){
                this.setState({contactOptions: contactOptions});
            }
        }
        if(this.state.selectedVipPatchNumber === null && Boolean(this.props.account?.vipForwardingNumber)){
            setTimeout(() => {
                let phoneNumberId = this.props.user?.selfContact[0]?.contactMethods?.filter(item => item.contactMethodType === 'PHONE' && item.phoneNumber === this.props.account?.vipForwardingNumber)?.[0]?.contactMethodId;
                if(phoneNumberId !== undefined){
                    this.setState({selectedVipPatchNumber: phoneNumberId});
                } else {
                    this.setState({selectedVipPatchNumber: 'custom', vipPatchNumber: this.props.account?.vipForwardingNumber})
                }
            }, 500)
        }
    }

    componentDidMount(){
        document.title = 'Ruby - Settings';
        this.checkRecordingSelection();
    }

    componentDidUpdate() {
        this.checkRecordingSelection();
    }

    handleCallForwarding = (checked) => {
        this.setState({callForwadingChecked: checked});
    }

    handleForwardToRuby = (checked) => {
        this.setState({forwardToRubyChecked: checked});
    }

    state = {
        selectedVoiceMailId: 'PERSONAL',
        mouseState: 'left',
        emails: '',
        emails1: '',
        duration: 0,
        currentTime: 0,
        progress: 0,
        durationInterval: null,
        audioPlaying: false,
        contactOptions: [],
        vipPatchNumber: '',
        selectedVipPatchNumber: null
    }

    formatDuration = (duration) => {
        let seconds = 0;
        let minutes = 0;
        if(duration < 60){
            seconds = Math.floor(duration);
        } else {
            minutes = Math.floor(duration/60);
            seconds = Math.floor(((duration/60) - minutes) * 60);
        }
        if(minutes < 10){ minutes = '0' + minutes};
        if(seconds < 10){ seconds = '0' + seconds};
        return {minutes, seconds};
    }

    getDuration = (event) => {
        if(event === 'started'){
            this.setState({audioPlaying: true});
            this.setState({ durationInterval: setInterval(() => {
                this.setState({progress: (document.getElementById('audio')?.currentTime/this.state.duration)*100})
            }, 100)})
        } else if(event === 'ended'){
            this.setState({audioPlaying: false, progress: 0});
            clearInterval(this.state.durationInterval);
        } else {
            this.setState({audioPlaying: false})
            clearInterval(this.state.durationInterval);
        }
    }

    handleSeek = (event, newValue) => {
        const audioElement = document.getElementById('audio');
        const calculatedValue = (newValue/100) * this.state.duration;
        audioElement.currentTime = calculatedValue;
        this.setState({ progress: newValue });
      };

    createVipForwardingNumber = () => {
        if(this.state.selectedVipPatchNumber === 'custom'){
            if(this.state.vipPatchNumber?.length === 12){
                this.props.updateVipForwardingNumber(this.props.account?.accountId, this.state.vipPatchNumber);
            } else {
                this.props.updateVipForwardingNumber(this.props.account?.accountId, null);
            }
        } else {
            let phoneNumber = this.props.user?.selfContact[0]?.contactMethods?.filter(item => item.contactMethodId === this.state.selectedVipPatchNumber)[0]?.phoneNumber;
            this.props.updateVipForwardingNumber(this.props.account?.accountId, phoneNumber);
        }
    }

    render() {
        const { classes, account, setPhoneOpen, phoneOpen, recordIvr, queryAccount, user, updateUser } = this.props;

        let recordingUrl = account?.recordings?.filter(recording => recording.recordingId === this.state.selectedVoiceMailId)[0]?.recordingUrl;
        let disablePlay = account?.recordings?.filter(recording => recording.recordingId === this.state.selectedVoiceMailId)[0]?.inDb === 'N' && account?.recordings?.filter(recording => recording.recordingId === this.state.selectedVoiceMailId)[0]?.onTwilio === 'N';
        let recordingDuration = account?.recordings?.filter(recording => recording.recordingId === this.state.selectedVoiceMailId)[0]?.duration

        return(
            <React.Fragment>
                <MuiCore.Grid item lg={12} md={12} className={classes.flexContainer}>
                    <MuiCore.Grid lg={6} style={{alignSelf: 'center', marginLeft: 20}}>
                        <MuiCore.Grid container className={classes.leftSide} spacing={2}>
                            <AccountSelect className={classes.flexItemRoot} addUserRoles='Y' accountChanged={(accountId) => {
                                this.setState({selectedVipPatchNumber: null, vipPatchNumber: ''});
                            }}/>
                        </MuiCore.Grid>
                    </MuiCore.Grid>
                </MuiCore.Grid>
                {user.userAccountRoles.find(u => u.accountId === account.accountId)?.userRoleKey === 'GLOBALADMIN' && <MuiCore.Grid style={{paddingLeft: 50, paddingTop: 20}}>
                    <MuiCore.Typography className={classes.headings}>VIP Forwarding Number</MuiCore.Typography>
                    <MuiCore.Grid>
                        <MuiCore.Grid style={{display: 'flex', flexDirection: 'row'}}>
                            <MuiCore.Typography className={classes.details} style={{marginTop: 20}}>Forward VIP calls for <span>
                                {account?.accountName}
                                </span> to </MuiCore.Typography>
                                <MuiCore.Grid style={{width: 300,marginTop: 15, marginLeft: 10}}> 
                                    <MuiCore.Select value={this.state.selectedVipPatchNumber}
                                                    onChange={(event) => this.setState({selectedVipPatchNumber: event.target.value})}
                                                    className={classes.numberSelect}
                                                    fullWidth
                                                    input={<MuiCore.OutlinedInput/>}>
                                        {user?.selfContact[0]?.contactMethods?.filter(item => item.contactMethodType === 'PHONE')?.map(number =>(
                                            <MuiCore.MenuItem key={number.contactMethodId}
                                                            className={classes.numberSelect}
                                                                value={number.contactMethodId}>
                                                {Formatters.formatPhoneNumber(number.phoneNumber)}
                                            </MuiCore.MenuItem>                    
                                        ))}
                                        <MuiCore.MenuItem key={'custom'}
                                                            className={classes.numberSelect}
                                                            value={'custom'}>
                                            {'Custom Number'}
                                        </MuiCore.MenuItem>    
                                    </MuiCore.Select>
                                </MuiCore.Grid>
                                {this.state.selectedVipPatchNumber === 'custom' && <MuiCore.Grid style={{width: 300,marginTop: 15, marginLeft: 10}}> 
                                    <PhoneTextFieldWithFlag 
                                        value={this.state.vipPatchNumber} 
                                        onPhoneNumberChange={(phoneNumber) => {
                                            this.setState({vipPatchNumber: phoneNumber})
                                        }}
                                    />
                                </MuiCore.Grid>}
                        </MuiCore.Grid>
                        <MuiCore.Grid>
                            <MuiCore.Button 
                            // Disabled valid checks as per #547
                            // disabled={(this.state.vipPatchNumber?.length !== 12 && this.state.selectedVipPatchNumber === 'custom') ||
                            //                           (this.state.selectedPhoneNumber === null) ||
                            //                           (this.state.selectedVipPatchNumber === null && this.state.selectedVipPatchNumber !== 'custom') } 
                                            onClick={this.createVipForwardingNumber}>
                                Save
                            </MuiCore.Button>
                        </MuiCore.Grid>
                    </MuiCore.Grid>
                </MuiCore.Grid>}
                <MuiCore.Grid style={{padding: 50}}>
                    <CallFowarding/>
                </MuiCore.Grid>
                <MuiCore.Divider style={{ marginRight: 30}}/>

                {<MuiCore.Grid style={{padding: 50}}>
                    <MuiCore.Typography className={classes.headings}>Voicemail Recording</MuiCore.Typography>
                    <MuiCore.Select 
                        value={this.state.selectedVoiceMailId}
                        style={{fontFamily: 'Sofia', minWidth: 400}}
                        onChange={(event) => {
                            this.setState({selectedVoiceMailId: event.target.value, duration: 0, audioPlaying: false})
                            document.getElementById('audio').pause();
                        }}
                    >
                         <MuiCore.MenuItem value={'PERSONAL'} className={classes.details}>{'Personal Voicemail'}</MuiCore.MenuItem>
                        {account?.recordings?.map(item => (
                            <MuiCore.MenuItem value={item.recordingId} className={classes.details}>{item.name}</MuiCore.MenuItem>
                        ))}
                    </MuiCore.Select>
                    <MuiCore.Grid style={{display: 'flex', flexDirection: 'row', marginTop: 20}}>
                        {this.state.audioPlaying ? <PauseIcon style={{color: '#B61256', cursor: 'pointer'}} fontSize='large' onClick={() => {
                            document.getElementById('audio').pause()
                        }}/> : <PlayIcon style={{color: '#B61256', cursor: 'pointer'}} fontSize='large' onClick={() => {
                            if(!disablePlay)
                            document.getElementById('audio').play()
                        }}/>}
                        <MuiCore.Slider value={this.state.progress} onChangeCommitted={this.handleSeek} style={{width: 400, margin: 5, marginLeft: 10 }}/>
                        <MuiCore.Typography className={classes.minutesPlayed}>{this.formatDuration(this.state.duration).minutes + ':' + this.formatDuration(this.state.duration).seconds}</MuiCore.Typography>
                        <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 14, color: this.state.mouseState === 'record' ? '#E5196C' : '#09122B', fontWeight: 400, margin: 7 }} onClick={() => {
                            setPhoneOpen(!phoneOpen)
                            recordIvr(this.state.selectedVoiceMailId, () => {
                                if(this.state.selectedVoiceMailId === 'PERSONAL'){
                                    updateUser();
                                } else {
                                    queryAccount();
                                }   
                            });
                        }}>
                            <span style={{cursor: 'pointer'}} onMouseEnter={()=>{this.setState({mouseState: 'record'})}} onMouseLeave={()=>{this.setState({mouseState: 'left'})}}>
                                {'Re-Record'}
                            </span>
                        </MuiCore.Typography>
                    </MuiCore.Grid>
                    <MuiCore.Grid>
                        <audio style={{width: 500}} onLoadedMetadata={(event) => {
                            this.setState({ duration: this.state.selectedVoiceMailId === 'PERSONAL' ? (user?.greeting[0]?.duration || event?.target?.duration || 0) : (recordingDuration || event?.target?.duration || 0) })
                        }} onEnded={(event) => {
                            this.getDuration('ended');
                        }} onPlay={() => {
                            this.getDuration('started');
                        }} onPause={() => {
                            this.getDuration('paused');
                        }} src={this.state.selectedVoiceMailId === 'PERSONAL' ? user?.greeting[0]?.recordingUrl : recordingUrl} id='audio' hidden controls/>
                    </MuiCore.Grid>
                </MuiCore.Grid>}
                {/* <MuiCore.Divider style={{ marginRight: 30}}/> */}

                {/* <MuiCore.Grid style={{padding: 50}}>
                    <MuiCore.Typography class={classes.headings}>Email Notifications</MuiCore.Typography>
                    <MuiCore.Typography class={classes.details}>In addition to emails for messages and voicemails, send notifications for:</MuiCore.Typography>
                    <MuiCore.Typography style={{fontFamily: 'Sofia-bold', marginTop: 20}}>All calls</MuiCore.Typography>
                    <MuiCore.TextField style={{width: 400, marginTop: 10}} InputProps={{ style: {fontFamily: 'Sofia', fontSize: 14}}} variant='outlined' placeholder='Enter email address(es), separated by commas.' value={this.state.emails} onChange={(event)=>this.setState({emails: event.target.value})} />
                    <MuiCore.Typography style={{fontFamily: 'Sofia-bold', marginTop: 20}}>Connected Calls Only</MuiCore.Typography>
                    <MuiCore.TextField style={{width: 400, marginTop: 10}} InputProps={{ style: {fontFamily: 'Sofia', fontSize: 14}}} variant='outlined' placeholder='Enter email address(es), separated by commas.' value={this.state.emails1} onChange={(event)=>this.setState({emails1: event.target.value})} />
                    <MuiCore.Grid style={{display: 'flex', flexDirection: 'row', marginTop: 20}}>
                        <MuiCore.Button style={{marginRight: 10}}>Cancel</MuiCore.Button>
                        <MuiCore.Button style={{marginLeft: 10}}>Save</MuiCore.Button>
                    </MuiCore.Grid>
                </MuiCore.Grid> */}
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return({
        user: coreSelectors.getUser(state),
        account: accountSelectors.getAccount(state),
        phoneOpen : phoneSelectors.getPhoneOpen(state),
    })
}

const mapDispatchToProps = {
    setPhoneOpen : phoneActions.setPhoneOpen,
    recordIvr : phoneActions.recordIvr,
    playIvr: phoneActions.playIvr,
    queryAccount : accountActions.queryAccount,
    updateUser: coreActions.updateUser,
    updateVipForwardingNumber: serviceActions.updateVipForwardingNumber,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RubySettings));